module.exports = __webpack_public_path__ + "media/images/advisers/img_honma-a252ce85187ad8b6cb19368475b102f7.jpg";